import React from 'react';
import {Descriptions, Space} from 'antd';
import {useTranslation} from 'react-i18next';

export default function BillingPlanSummary({org}) {
    const {t} = useTranslation();
    const planName = org?.free
        ? t('free', 'Free')
        : org?.custom_pricing || org?.private_pricing
            ? t('custom-plan', 'Custom plan')
            : StripeProducts[org?.stripe_product_code]?.name || org?.stripe_product_code?.replaceAll('_', ' ') || t('pending', 'Pending');

    const stored = org?.stripe_coupon;
    const storedCoupon = stored?.coupon?.table || stored?.coupon;
    const discounts = (stored?.discounts || (storedCoupon ? [{...stored, ...storedCoupon}] : [])).filter(discount => {
        const endsAt = discount.ends_at ?? discount.end;
        return endsAt == null || Number(endsAt) > Date.now() / 1000;
    });
    const discountLabel = discount => {
        const amount = discount.amount_off_cents ?? discount.amount_off;
        const savings = discount.percent_off != null
            ? `${discount.percent_off}% ${t('off', 'off')}`
            : amount != null && discount.currency
                ? `${new Intl.NumberFormat('en-US', {style: 'currency', currency: discount.currency}).format(amount / 100)} ${t('off', 'off')}`
                : null;
        const restricted = discount.applies_to_product_ids?.length || discount.applies_to?.products?.length;
        return [discount.name, savings, discount.duration === 'forever' ? t('ongoing', 'ongoing') : null,
            restricted ? t('discount-selected-products', 'Applies to selected products') : null].filter(Boolean).join(' · ');
    };

    return <Space direction="vertical" style={{width: '100%'}} data-testid="billing-plan-summary">
        <Descriptions bordered size="small" column={1}>
            <Descriptions.Item label={t('plan', 'Plan')}>{planName}</Descriptions.Item>
            {!org?.free && <Descriptions.Item label={t('term', 'Term')}>
                {org?.stripe_interval === 'year' ? t('annual', 'Annual') : org?.stripe_interval === 'month' ? t('monthly', 'Monthly') : t('pending', 'Pending')}
            </Descriptions.Item>}
            {discounts.map((discount, index) => <Descriptions.Item label={t('discount', 'Discount')} key={discount.id || discount.coupon_id || index}>
                {discountLabel(discount)}
            </Descriptions.Item>)}
        </Descriptions>
        <p>{t('billing-plan-managed', 'Contact the Mediagraph billing team to review your pricing or request a plan change.')}</p>
        <a href="mailto:billing@mediagraph.io">{t('request-plan-change', 'Request a plan change')}</a>
    </Space>;
}
